import { render } from "./Freebies.vue?vue&type=template&id=6ec30562"
import script from "./Freebies.vue?vue&type=script&lang=js"
export * from "./Freebies.vue?vue&type=script&lang=js"

import "./Freebies.vue?vue&type=style&index=0&id=6ec30562&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__